import { jsx as _jsx } from "react/jsx-runtime";
import { Children, useContext } from 'react';
import PropertyCardContext from '@components/PropertyCard/PropertyCardContext';
import { OverviewContainer } from './Overview.style';
const Overview = ({ children }) => {
    const { isCardSelected } = useContext(PropertyCardContext);
    const bricksSummaryLength = Children.toArray(children).filter(Boolean).length;
    return (_jsx(OverviewContainer, { isCardSelected: isCardSelected, bricksSummaryLength: (bricksSummaryLength), children: children }));
};
export default Overview;
